import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconFailed } from 'src/assets/icons/icon-failed.svg';

import { ERequestStatus } from 'src/api/enumRequest';
import { useCustomSearchParams } from 'src/hook';

import { selectStatusGetPayment } from 'src/store/slice/payment/state';

import PopupContent from 'src/components/popups/popupContent';

import './popup-error-payment.scss';

const PopupErrorPayment: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const { isDemo, paymentId } = useCustomSearchParams();

  const statusGetPayment = useSelector(selectStatusGetPayment);

  const [isShowPopup, setShowPopup] = useState<boolean>(false);

  /**
   * useEffect show popup error payment
   */
  useEffect(() => {
    if (!isDemo && (!paymentId || statusGetPayment === ERequestStatus.failed)) {
      setShowPopup(true);
    }
  }, [isDemo, paymentId, statusGetPayment]);

  return (
    <PopupContent
      wrapperClass="popup-error"
      visible={isShowPopup}
      title={t('POPUP_ERROR_PAYMENT_TITLE.PAYMENT_HAS_ERROR') || undefined}
    >
      <i className="popup-error-icon">
        <IconFailed />
      </i>

      <p className="popup-error-description">{t('POPUP_ERROR_PAYMENT_DESCRIPTION.INVALID_PAYMENT_INFORMATION')}</p>
    </PopupContent>
  );
};

export default PopupErrorPayment;
